import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

// Development API URL management
let devCustomApiUrl: string | null = null;

// Function to get the current API host
export const getApiHost = async (): Promise<string> => {
	// In development, check for custom API URL
	if (__DEV__) {
		try {
			const savedUrl = await AsyncStorage.getItem('dev_custom_api_url');
			if (savedUrl && savedUrl.trim()) {
				console.log('Using custom API URL:', savedUrl);
				return savedUrl;
			}
		} catch (error) {
			console.warn('Failed to load custom API URL:', error);
		}
	}

	// Default host configuration
	const defaultHost =
		Platform.OS != 'web'
			? __DEV__
				? 'https://nonnutritious-sky-gamopetalous.ngrok-free.dev' // ngrok only in dev
				: process.env.EXPO_PUBLIC_API_URL
			: process.env.EXPO_PUBLIC_WEB_API;

	return defaultHost;
};

// Legacy HOST export for backward compatibility
export const HOST =
	Platform.OS != 'web'
		? __DEV__
			? 'https://nonnutritious-sky-gamopetalous.ngrok-free.dev' // ngrok only in dev
			: process.env.EXPO_PUBLIC_API_URL
		: process.env.EXPO_PUBLIC_WEB_API;

export const AI_API_URL =
	Platform.OS != 'web'
		? `${process.env.EXPO_PUBLIC_AI_MOBILE_API}`
		: process.env.EXPO_PUBLIC_AI_API;
export const AI_CHAT_API_URL = `${process.env.EXPO_PUBLIC_AI_CHAT_API}`;
export const AI_MODEL = `${process.env.EXPO_PUBLIC_AI_MODEL}`;

// Dynamic API base URL that respects development custom URLs
export const getApiBaseUrl = async (): Promise<string> => {
	const host = await getApiHost();
	return `${host}/api`;
};

// Legacy export for backward compatibility
export const USER_API_BASE_URL = `${HOST}/api`;

// Function to update all axios instances with new base URL
export const updateApiBaseUrls = async (newHost?: string) => {
	const host = newHost || (await getApiHost());
	const baseUrl = `${host}/api`;

	// Update the global API instances
	if (typeof window !== 'undefined' && (window as any).apiInstances) {
		const instances = (window as any).apiInstances;
		if (instances.api) instances.api.defaults.baseURL = baseUrl;
		if (instances.noCreds) instances.noCreds.defaults.baseURL = baseUrl;
		if (instances.publicApi) instances.publicApi.defaults.baseURL = baseUrl;
		if (instances.sessionApi)
			instances.sessionApi.defaults.baseURL = `${host}/api/session`;
	}

	console.log('Updated API base URLs to:', baseUrl);
	return baseUrl;
};

export const STRIPE_URI = `${HOST}/stripe`;

export const LOGIN_API_URL = `${USER_API_BASE_URL}/login`;

export const PCO_SYSTEM_API_URL = `${USER_API_BASE_URL}/systems`;

export const USER_ACTION_HISTORY = `${USER_API_BASE_URL}/userActionHistory`;

export const AVATAR_UPLOAD = `${USER_API_BASE_URL}/upload/`;

export const GET_AVATAR_URL = `${USER_API_BASE_URL}/image`;

export const NEW_USER_ADDED = `${USER_API_BASE_URL}/registeruser`;

export const SESSION_API = `${USER_API_BASE_URL}/session`;

export const WEATHER_API_KEY = `26d18df2b88c8184fbc6d80c0ae2da66`;

export const NEWS_API_KEY = `GfdrfLQWB5WAkb6DaYEnWT6Or9Zx62547BrDl3_XBh4`;

export const LINKEDIN_CLIENT_ID = '78zyjbrtiha5t3';

export const COMPANIESHOUSE_API_KEY = '4d57ab9a-b311-4f16-b71b-a811ced9e95c';
